import * as React from 'react';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { CardMedia, Grid2 } from '@mui/material';
import { Icon } from '@iconify/react/dist/iconify.js';
import { CustomIconButton } from '../../utils/IconButton';
import CardContainer from '../../utils/CardContainer';
import ProgressBar from '../student/ProgressBar';
import MainDialogBox from '../Dialog/MainDialogBox';
import { useDialog } from '../../hook/useDialog';
import StudentAttendanceList from '../../../features/trainer/StudentAttendanceList';
import CustomDivider from '../../utils/CustomDivider';
import { Formik, Field, Form } from "formik";
import * as yup from "yup";
import MenuPopover from '../Menu/MenuPopover';
import { useMenu } from '../../hook/useMenu';
import { FileUploadFormField } from '../formfields/FileUploadFormField';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAuthStore from '../../../store/useAuthStore';
import { AbsentBtn, PresentBtn } from '../../utils/AttendaceButton';
import { formatToAmPm, getFormattedDate1 } from '../../formatter';
import { useStudentAtdStore } from '../../../store/useStudentAtdStore';
import { useToaster } from '../../utils/ToasterProvider';
import { useStudentListStatus } from '../../../assets/api/UseStudentGetApi';
import { ImagePath, ImageRelativePath } from '../../constants';
import { useTrainerMeeting } from '../../../assets/api/useTrainerGetApi';
import { getCourseStatusColor } from '../student/CurrentClassCard';
import api from '../../../assets/nodeApi/axiosInstance';
import dayjs from "dayjs";

const TrainerJoinClassCard = ({ item }) => {
    const {
        event_name,
        apartment_name,
        cover_image,
        start_date,
        start_time,
        course_id,
        apartment_id,
        batch_id,
        facility_name,
        batch_name,
        end_date,
        type,
        status
    } = item
    const queryClient = useQueryClient();
    const { data: meetingLink } = useTrainerMeeting({ batchId: batch_id })
    const { open, handleClickOpen, handleClose } = useDialog();
    const { token, user } = useAuthStore();
    const { open: openTrainerAtd, handleClickOpen: handleClickOpenTrainerAtd, handleClose: handleCloseTrainerAtd } = useDialog();
    const { open: openUpload, handleClickOpen: handleClickOpenUpload, handleClose: handleCloseUpload } = useDialog();
    const { anchorEl, openMenu, handleMenuOpen, handleMenuClose } = useMenu();
    const { showToaster } = useToaster();
    const menuItems = React.useMemo(() => {
        const items = [];
        if (type !== 'online') {
            if (status === "Completed Class") {
                items.push({
                    label: "Upload Photo",
                    onClick: () => {
                        handleClickOpenUpload();
                        handleMenuClose();
                    },
                });
            }
            if (status !== "Upcoming Class") {
                items.push({
                    label: "Add Your Addendance",
                    onClick: () => {
                        handleClickOpenTrainerAtd()
                        handleMenuClose();
                    },
                });
            }
        }
        return items;
    }, [status, handleClickOpenUpload, handleMenuClose]);


    const createMemoryMutation = useMutation({
        mutationFn: (formData) => api.post("student-memories/create", formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }),
    });

    const handleSubmitFileUpload = (values, { resetForm }) => {
        const formData = new FormData();
        formData.append('memories_images', values.image);
        formData.append('course_id', course_id);
        formData.append('trainer_id', user?.id);
        formData.append('created_by', user?.id);
        formData.append('updated_by', user?.id);
        formData.append('apartment_id', apartment_id);
        formData.append('batch_id', batch_id);
        createMemoryMutation.mutate(formData, {
            onSuccess: (response) => {
                if (response?.data?.message) {
                    showToaster(response?.data?.message, '', 'success')
                    handleCloseUpload();
                    resetForm();
                } else {
                    showToaster('Something went wrong!', 'Something went wrong!', 'error')
                }
            },
            onError: (error) => {
                showToaster(error?.data?.error, 'Something went wrong!', 'error')
            }
        });
    };
    const createTrainerAtdMutation = useMutation({
        mutationFn: (formData) => api.post("trainer-attendance/store", formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }),
    });
    const handleTrainerAtd = () => {
        const obj = {
            "course_id": course_id,
            "trainer_id": user?.id,
            "apartment_id": apartment_id,
            "attendance_status": 1,
            "batch_id": batch_id,
            "facility_id": null
        };
        createTrainerAtdMutation.mutate(obj, {
            onSuccess: (response) => {
                if (response?.data?.message) {
                    showToaster(response?.data?.message, '', 'success')
                    handleCloseTrainerAtd();

                } else {
                    showToaster('Something went wrong!', '', 'error')
                }
            },
            onError: (error) => {
                console.log(error, "error")
                showToaster(error?.response?.data?.message, '', 'error')
            }
        });

    }
    const { data, removeAll } = useStudentAtdStore();
    const createMutation = useMutation({
        mutationFn: (formData) => api.post("student-attendance/create", formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }),
    });
    const { data: studentlist } = useStudentListStatus({ course_id: course_id, apartment_id: apartment_id, batch_id: batch_id });
    const handleStudentAtd = () => {
        const obj = {
            student_data: data,
            trainer_id: user?.id,
            attendance_date: getFormattedDate1(),
            course_id: course_id,
            batch_id: batch_id,

        }
        const allPresent = studentlist?.data?.every(student => student.attendance_status === 1);
        if (allPresent) {
            showToaster('Attendance has already been added for All  student.', 'Warning', 'warning')
            return;
        }
        createMutation.mutate(obj, {
            onSuccess: (response) => {
                if (response?.data?.message) {
                    showToaster('Student Attendance Added', '', 'success')
                    handleClose()
                    queryClient.invalidateQueries({ queryKey: ['students-by-trainer-status'] });
                } else {
                    showToaster('Something went wrong!', '', 'error')
                }
            },
            onError: (error) => {
                showToaster(error?.data?.error || 'Something went wrong', '', 'error')
            }

        });
        setTimeout(() => {
            removeAll();
        }, 300);

    }

    const handleStartDemo = () => {
        if (meetingLink?.start_url) {
            window.open(meetingLink.start_url, '_blank');
            handleTrainerAtd()
        }
    }


    const details = [
        { label: "Batch", value: batch_name },
        ...(type === "offline"
            ? [
                { label: "Facility", value: facility_name },
                { label: "Apartment Name", value: apartment_name },
            ]
            : []),
    ];

    const additionalDetails = [
        { label: "Status", value: status },
        { label: "Mode", value: type === "offline" ? "Offline" : "Online" },
    ];

    const hasOpenedRef = React.useRef(false);
    React.useEffect(() => {
        if (!start_time || status !== "Ongoing Class") return;

        const checkTime = () => {
            const now = dayjs();
            const [hour, minute] = start_time.split(":").map(Number);
            const start = dayjs()
                .hour(hour)
                .minute(minute)
                .second(0);

            const diff = now.diff(start, "minute");
            if (diff >= 0 && diff < 2 && !hasOpenedRef.current) {
                hasOpenedRef.current = true;
                handleClickOpenTrainerAtd();
            }
        };

        checkTime();

        const interval = setInterval(checkTime, 5000);

        return () => clearInterval(interval);
    }, [start_time, status]);

    return (
        <>
            <CardContainer>
                <CardMedia
                    sx={{
                        width: { lg: "35%", xs: "100%" },
                        borderRadius: "15px",
                        height: { lg: "auto", xs: "200px" }
                    }}
                    image={`${ImagePath}${ImageRelativePath}${cover_image}`}
                />
                <CardContent sx={{ flex: 1, px: { lg: "15px", xs: "0" } }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                        <Box>
                            <Typography variant='h5'>{event_name}</Typography>
                            <Typography variant='h6' color='secondary.light'>{start_date} - {end_date}</Typography>
                        </Box>
                        {
                            menuItems?.length !== 0 && <CustomIconButton icon={<Icon icon="ph:dots-three-outline-vertical-fill" color='#D9D9D9' height="30" />} onClick={handleMenuOpen} />
                        }


                    </Box>
                    {[details, additionalDetails].map((group, index) => (
                        <Box key={index}>
                            {group.map(({ label, value }, idx) => (
                                <Typography key={idx} fontSize={"13px"} variant="body2">
                                    {label} : {" "}
                                    {value ? (
                                        label === "Status" ? (
                                            <>
                                                <Typography
                                                    component="span"
                                                    fontSize={"13px"}
                                                    sx={{ color: getCourseStatusColor(status) }}
                                                >
                                                    {value}
                                                </Typography>

                                            </>

                                        ) : (
                                            value
                                        )
                                    ) : (
                                        ""
                                    )}
                                </Typography>
                            ))}

                        </Box>

                    ))}

                    <Box my={2}> <ProgressBar /></Box>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Button
                            variant='contained'
                            fullWidth
                            onClick={type === "offline" ? handleClickOpen : handleStartDemo}
                            disabled={status !== "Ongoing Class"}
                        >
                            {type === "offline" ? "Add Student Attendance" : "Start Class"}
                        </Button>

                    </Box>
                </CardContent>
            </CardContainer>
            <MainDialogBox open={open} handleClose={() => {
                handleClose();
                setTimeout(() => {
                    removeAll();
                }, 300);
            }} heading={"Student Attendance"}>
                <CustomDivider />
                <CustomDivider />
                <StudentAttendanceList item={item} />
                <Box sx={{ display: 'flex', justifyContent: "center", mt: 2 }}>
                    <Button variant='contained' onClick={handleStudentAtd}>Submit</Button>
                </Box>
            </MainDialogBox>
            <MainDialogBox open={openUpload} handleClose={handleCloseUpload} heading={"Classroom Attendance Verification: Photo Submission"} width={"40%"}>
                <Formik initialValues={{ image: "" }} validationSchema={yup.object().shape({
                    image: yup.string().required("Please Upload File")
                })} onSubmit={handleSubmitFileUpload}>
                    {() => (
                        <Form >
                            <Grid2 container spacing={3} >
                                <Grid2 children size={{ xs: 12 }}>
                                    <Field
                                        name="image"
                                        component={FileUploadFormField}
                                        label="Upload Profile Picture"
                                    />
                                </Grid2>
                                <Grid2 children size={{ xs: 12 }}>
                                    <Button variant='contained' fullWidth type="submit" >  {createMemoryMutation.isLoading ? "Uploading..." : "Upload"}
                                    </Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </MainDialogBox>
            <MainDialogBox open={openTrainerAtd} handleClose={handleCloseTrainerAtd} heading={"Teacher's Attendance"} width={"60%"}>
                <Typography variant='body2'>Welcome, Teacher's ! Please confirm your attendance for today’s class</Typography>
                <Box sx={{ display: "flex", justifyContent: "space-around", alignItems: "center" }}>
                    <Typography variant='body2' sx={{ bgcolor: "#F4F7FF", borderRadius: 1, p: 1 }}>Subject : {event_name}</Typography>
                    <Typography variant='body2' sx={{ bgcolor: "#F4F7FF", borderRadius: 1, p: 1 }}>Date : {start_date}</Typography>
                    <Typography variant='body2' sx={{ bgcolor: "#F4F7FF", borderRadius: 1, p: 1 }}>Time : {formatToAmPm(start_time)}</Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-around", my: 2 }}>
                    <PresentBtn onClick={handleTrainerAtd} />
                    <AbsentBtn onClick={handleCloseTrainerAtd} />
                </Box>
            </MainDialogBox>
            <MenuPopover
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleMenuClose}
                menuItems={menuItems}
            />
        </>
    )
}

export default TrainerJoinClassCard 